// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"927b7c35","453":"b1a84254","455":"4707173a","977":"b6e71dc0"}[chunkId] + ".chunk.js";
};